import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

/* Masked line reveal — wraps element and slides content up from behind a clip */
export function maskReveal(el, opts = {}) {
  gsap.fromTo(el,
    { yPercent: 115 },
    {
      yPercent: 0, duration: opts.duration ?? 1.05, ease: 'power4.out',
      stagger: opts.stagger ?? 0.08, delay: opts.delay ?? 0,
      scrollTrigger: opts.scroll === false ? undefined : {
        trigger: opts.trigger ?? el, start: opts.start ?? 'top 88%'
      }
    }
  )
}

export { gsap }
